export default "__VITE_ASSET__tECT3Sb$__"